<div class="w-100 h-100 d-flex flex-column">
  <app-rental-agreement-filter [initialState]="initialFilterState" (onFilterChange)="filterChanged($event)" />
  <app-api-paginated-grid
    [listOperator]="listRentalAgreementsOperator"
    [createOperator]="createRentalAgreementOperator"
    [updateOperator]="updateRentalAgreementOperator"
    [deleteOperator]="deleteRentalAgreementOperator"
    [columnDefs]="columnDefs" />
</div>
